import React from 'react';

const WhatsAppButton = () => {
  return (
    <div className="whatsapp-float-button">
      <a
        href="https://wa.me/584241778034"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float-link"
        aria-label="Chat on WhatsApp"
      >
        <span className="whatsapp-icon" aria-hidden="true">💬</span>
      </a>
    </div>
  );
};

export default WhatsAppButton;
